module.exports = "/images/map-marker-half.png?acf86be11df2860325812b46f3145083";